import ComingSoon from "@/components/ComingSoon";

const DeviceEnrollmentPage = () => {
  return <ComingSoon featureName="Device Enrollment" description="Enroll new devices into management. This feature requires backend End-User Portal APIs." />;
};

export default DeviceEnrollmentPage;
